

export const DATA_TABLE_TREE_STYLE_TYPE = {
  ACCORDION: 'accordion',
  SIMPLE: 'simple'
};